import { DIMENSIONS, RITUAL, PRINCIPLES } from "@/data/constants";
import { DimensionCard } from "@/components/DimensionCard";
import { SectionHead } from "@/pages/Home";

export default function Methode() {
  return (
    <div>
      <section className="bg-[#F8F5EE] border-b border-[#E8DCC4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-16 md:py-24 text-center">
          <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#C9A24B] font-semibold">
            Le Tao des 4C
          </p>
          <h1 className="font-serif text-4xl md:text-5xl text-[#1F2A24] mt-3">La Méthode</h1>
          <div className="gold-divider w-24 mx-auto my-6" />
          <p className="font-sans text-base md:text-lg text-[#1F2A24]/80 leading-relaxed">
            Une méthode intégrative pour retrouver un alignement intérieur en reliant quatre
            dimensions. Inspirée du taoïsme et du principe du <strong>Wu Wei</strong> — agir sans
            forcer.
          </p>
          <p className="font-serif italic text-xl text-[#1F2A24]/70 mt-6">
            Ne pas lutter contre soi. Observer. Écouter. S'aligner. Agir avec plus de fluidité.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16 md:py-20">
        <SectionHead eyebrow="Les dimensions" title="Les 4 C" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
          {DIMENSIONS.map((d) => (
            <DimensionCard key={d.key} dim={d} testid={`methode-card-${d.key}`} />
          ))}
        </div>
      </section>

      <section className="bg-[#F8F5EE] border-y border-[#E8DCC4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 md:py-20">
          <SectionHead eyebrow="Inspirations taoïstes" title="Les principes" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 mt-10">
            {PRINCIPLES.map((p, i) => (
              <div
                key={p.title}
                data-testid={`principle-${i}`}
                className="rounded-2xl bg-white border border-[#E8DCC4] p-6"
              >
                <h3 className="font-serif text-xl text-[#385E3A]">{p.title}</h3>
                <p className="font-sans text-sm text-[#1F2A24]/75 mt-2 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-16 md:py-20">
        <SectionHead eyebrow="Chaque jour" title="Le rituel quotidien" center />
        <div className="flex flex-wrap justify-center items-center gap-3 mt-10">
          {RITUAL.map((step, i) => (
            <div key={step} className="flex items-center gap-3">
              <span
                data-testid={`methode-ritual-${i}`}
                className="rounded-full bg-white border border-[#C9A24B]/40 px-5 py-2.5 font-serif text-[#1F2A24]"
              >
                {step}
              </span>
              {i < RITUAL.length - 1 && <span className="text-[#C9A24B]">→</span>}
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#1F2A24] text-[#F6F2E9]">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-16 md:py-20 grid md:grid-cols-2 gap-10">
          <div>
            <h3 className="font-serif text-2xl text-[#C9A24B]">Le protocole des 21 jours</h3>
            <p className="font-sans text-sm text-[#F6F2E9]/80 mt-3 leading-relaxed">
              Vingt-et-un jours pour intégrer la méthode dans votre quotidien. Chaque jour : une
              carte, une question, une expérience, une action. Une porte d'entrée simple, à votre
              rythme.
            </p>
          </div>
          <div>
            <h3 className="font-serif text-2xl text-[#C9A24B]">Le journal des 4C</h3>
            <p className="font-sans text-sm text-[#F6F2E9]/80 mt-3 leading-relaxed">
              Un espace d'écriture privé pour noter ce que vous avez compris, ressenti et
              expérimenté. Vos réponses restent les vôtres.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
